(function() {
  'use strict';

  angular
    .module('video.videoDirective', [
      'factories.mobileHelper',
      'factories.spinnerHelper'
    ])
    .directive('mfVideo', mfVideo);

  mfVideo.$inject = ['MobileHelper', 'Sension', 'FrameStateProgressHelper', '$rootScope', 'SpinnerHelper', 'Navigation',
    '$timeout', 'Utils', '$window'];

  function mfVideo(MobileHelper, Sension, FrameStateProgressHelper, $rootScope, SpinnerHelper,
                   Navigation, $timeout, Utils, $window) {
    return {
      link: function(scope, element, attr) {
        var videoJsPlayer;
        var videoContainer = $('#videoContainer');
        var videoState;
        var videoControl;
        var states;
        var intervalId;
        var pluginBlockedTimeoutPromise;
        var videoNotLoadedTimeoutPromise;
        var pausedWhileEngaged;
        var pausedBeforeVideoSourceChange = false;
        var isTrackingProgress = false;
        var usingFlash = false;
        var isChrome = $window.BrowserDetect && $window.BrowserDetect.browser == 'Chrome';

        var outer = $($window);
        var windowElement = $($window);
        var videoJsElem = $('#video');
        var copyOfVideoElem = null;
        var rawVideoElem = null;
        var videoWrapper = $('#video-wrapper');
        var videoBorder = $('.video-border');
        var videoOuter = $('.video-outer');
        var hlsEndOfVideoBuffer = (MobileHelper.supportsHLS() && !MobileHelper.willGoNativeFullScreen() ? 0.5 : 0); // only need to do this if using HLS
        var justEnded = false;
        var canPlay = false;
        var lastSeenCurrentTime = 0;
        var onErrorRetry = true;
        var retryableErrorCodes = [2, 3, 4];
        var hasRetriedAfterVideoNotLoading = false;

        if (MobileHelper.isIOS())
          videoWrapper.addClass('ios');

        var isIE9 = $window.BrowserDetect && $window.BrowserDetect.browser === 'Explorer' && $window.BrowserDetect.version == 9;

        scope.hasFlash = $window.swfobject && $window.swfobject.hasFlashPlayerVersion('10.1');
        scope.canPlayHtml5Video = true; // Assume we can play HTML5 video.
        if ($window.Modernizr)
          scope.canPlayHtml5Video = $window.Modernizr.video && $window.Modernizr.video.h264 != '';

        scope.lastSeenCurrentTime = null;

        scope.lastLoadStep = 'directive loaded';

        scope.hasPlayed = false;
        scope.currentSourceHasPlayed = false;
        videoContainer.addClass('has-not-played');

        if (MobileHelper.isMobileDevice() && !MobileHelper.isNativeIpadApp)
          videoContainer.addClass('touch-to-play');

        if (MobileHelper.willGoNativeFullScreen())
          videoContainer.addClass('native-fullscreen');

        $rootScope.isMuted = $rootScope.isMuted || false;

        var isIE11 = !!(navigator.userAgent.match(/Trident/) && !!navigator.userAgent.match(/rv:11/));
        var supportsFullscreen = $window.Modernizr && $window.Modernizr.fullscreen || isIE11;

        if (supportsFullscreen) {
          $window.document.addEventListener('fullscreenchange', onFullscreenChange, false);
          $window.document.addEventListener('webkitfullscreenchange', onFullscreenChange, false);
          $window.document.addEventListener('mozfullscreenchange', onFullscreenChange, false);
          $window.document.addEventListener('MSFullscreenChange', onFullscreenChange, false);
        }

        scope.$watch('mediaState', function(newVideoState) {
          if (!newVideoState) return;
          videoState = newVideoState;
          states = videoState.states;
          setupVideoJS();
        });

        scope.$watch('mediaControl', function(newVideoControl) {
          if (!newVideoControl) return;
          videoControl = newVideoControl;

          videoControl.isPreview = scope.isPreview;
          videoControl.rawPlay = function() {
            if (!videoJsPlayer) return;

            if (videoJsPlayer.paused()) {
              videoJsPlayer.play();
              videoContainer.removeClass('touch-to-play');
            }
          };
          videoControl.rawPause = function() {
            if (!videoJsPlayer) return;

            if (!videoJsPlayer.paused())
              videoJsPlayer.pause();
          };
          videoControl.rawSeek = function(time) {
            if (!videoJsPlayer) return;

            videoJsPlayer.currentTime(time);
          };
          videoControl.canPlay = function() {
            if (rawVideoElem && rawVideoElem.length > 0 && rawVideoElem[0])
              return canPlay;
            return (videoJsPlayer && videoJsPlayer.bufferedPercent() > 0);
          };
          videoControl.haveEnoughData = function() {
            if (rawVideoElem && rawVideoElem.length > 0 && rawVideoElem[0])
              return rawVideoElem[0].readyState == 4;
            return (videoJsPlayer && videoJsPlayer.bufferedPercent() > 0);
          };
          videoControl.getCurrentTime = function() {
            if (videoState.deferredSeekTime)
              return videoState.deferredSeekTime;
            return videoJsPlayer ? videoJsPlayer.currentTime() : 0;

          };
          videoControl.getDuration = function() {
            return videoJsPlayer ? videoJsPlayer.duration() - hlsEndOfVideoBuffer : 0;
          };    //hlsEndOfVideoBuffer to be sure video ends before we reach the end and get the black quicktime screen
          videoControl.getBufferedPercent = function() {
            return videoJsPlayer ? videoJsPlayer.bufferedPercent() : 0;
          };
          videoControl.toggleMute = function() {
            if (!videoJsPlayer) return;
            $rootScope.isMuted = !$rootScope.isMuted;
            setVolume();
          };
          videoControl.requestFullscreen = function() {
            var usingFullscreenApi = false;
            if (!videoJsPlayer || !videoOuter) return;
            if (supportsFullscreen) {
              if (videoOuter[0].requestFullscreen) {
                videoOuter[0].requestFullscreen();
                usingFullscreenApi = true;
              } else if (videoOuter[0].msRequestFullscreen) {
                videoOuter[0].msRequestFullscreen();
                usingFullscreenApi = true;
              } else if (videoOuter[0].mozRequestFullScreen) {
                videoOuter[0].mozRequestFullScreen();
                usingFullscreenApi = true;
              } else if (videoOuter[0].webkitRequestFullscreen) {
                videoOuter[0].webkitRequestFullscreen();
                usingFullscreenApi = true;
              }
            }
            if (!usingFullscreenApi) {
              onFullscreen(videoState.fullscreenModes.largeVideo);
            }
          };
          videoControl.exitFullscreen = function() {
            var didBrowserExitFullscreen = false;
            if (!videoJsPlayer || !videoOuter) return;
            if (supportsFullscreen) {
              if ($window.document.exitFullscreen) {
                $window.document.exitFullscreen();
                didBrowserExitFullscreen = true;
              } else if ($window.document.msExitFullscreen) {
                $window.document.msExitFullscreen();
                didBrowserExitFullscreen = true;
              } else if ($window.document.mozCancelFullScreen) {
                $window.document.mozCancelFullScreen();
                didBrowserExitFullscreen = true;
              } else if ($window.document.webkitExitFullscreen) {
                $window.document.webkitExitFullscreen();
                didBrowserExitFullscreen = true;
              }
            }
            if (!didBrowserExitFullscreen) {
              onExitFullscreen();
            }
          };

          setupVideoJS();
        });

        function onFullscreenChange() {
          if ($window.document.fullscreenElement ||
            $window.document.webkitFullscreenElement ||
            $window.document.mozFullScreenElement ||
            $window.document.msFullscreenElement) {
            onFullscreen(videoState.fullscreenModes.fullscreenApi);
          } else {
            onExitFullscreen();
          }
        }

        function onFullscreen(fullscreenMode) {
          if (isChrome && usingFlash)
            videoOuter.addClass('flash-chrome');
          videoOuter.addClass('fullscreen-mode');
          videoState.fullscreen = fullscreenMode;
        }

        function onExitFullscreen() {
          videoOuter.removeClass('fullscreen-mode');
          videoState.fullscreen = videoState.fullscreenModes.none;
        }

        scope.getOuterWidth = function() {
          return outer.width();
        };

        scope.getOuterHeight = function() {
          return outer.height();
        };

        function setVolume() {
          if ($rootScope.isMuted)
            videoJsPlayer.volume(0);
          else
            videoJsPlayer.volume(1);
        }

        function resizeVideo() {
          if (!videoControl || !videoState || !videoJsPlayer) return;

          var height;
          var width;
          var containerHeight = videoContainer.height();
          var containerWidth = videoContainer.width();
          var outerWidth = outer.width();

          if (MobileHelper.isIOS && !MobileHelper.isNativeIpadApp)
            outerWidth = Math.max(outerWidth - 120, 0);

          if (MobileHelper.isNativeIpadApp) {
            containerHeight = windowElement.height();
            containerWidth = windowElement.width();
          }

          var outerHeight = outer.height();
          // If not in touch environment make room for fixed header/player controls.
          if (!MobileHelper.isTouch()) {
            outerHeight = outerHeight - 130;
          } else {
            outerHeight = outerHeight - 10;
          }

          if (MobileHelper.isNativeIpadApp) {
            // If we're running iPad app then make it full screen.
            height = containerHeight;
            width = containerWidth;
          } else {
            // If running on iOS but not in native app then we're still using HLS so assume running HD stream
            // and thus HD size.
            if (videoState.sourceType == videoState.sourceTypes.hd ||
              videoState.sourceType == videoState.sourceTypes.hls) {
              height = videoControl.slide.videoHDHeight;
              width = videoControl.slide.videoHDWidth;
            } else if (videoState.sourceType == videoState.sourceTypes.sd) {
              height = videoControl.slide.videoSDHeight;
              width = videoControl.slide.videoSDWidth;
            } else {
              height = videoControl.slide.videoLowQualityHeight;
              width = videoControl.slide.videoLowQualityWidth;
            }

            // Scale to fit in chrome
            if (height > outerHeight) {
              width = outerHeight / height * width;
              height = outerHeight;
            }
            if (width > outerWidth) {
              height = outerWidth / width * height;
              width = outerWidth - 2; // IE wants more pixels...
            }
          }

          width = Math.floor(width);
          height = Math.floor(height);

          // video js doesn't support percent based
          videoJsPlayer.dimensions(width, height);
          videoWrapper.css({
            width: width,
            height: height + 10
          });
        }

        scope.getHyperlinkStyle = function(link) {
          if (!link || !videoControl || !videoJsPlayer) return;

          var naturalHeight = videoControl.slide.videoHDHeight;
          var naturalWidth = videoControl.slide.videoHDWidth;
          var currentHeight = videoJsElem.height();
          var currentWidth = videoJsElem.width();
          var currentTop = parseInt(videoWrapper.css('padding-top')) || 0;

          return {
            height: Math.round((link.height / naturalHeight) * currentHeight),
            width: Math.round((link.width / naturalWidth) * currentWidth),
            left: Math.round((link.x / naturalWidth) * currentWidth),
            top: Math.round((link.y / naturalHeight) * currentHeight) + currentTop
          };
        };

        scope.$on('sensionIsEngagedChanged', function() {
          sensionEngagementChanged();
        });

        function sensionEngagementChanged() {
          if (!Sension.enabled() || !videoControl || !videoControl.play || !videoControl.pause)
            return;

          var videoContainerCss = {};

          if (Sension.faceHidden()) {
            videoContainerCss = {
              left: '-2000px',
              position: 'absolute'
            };
          } else {
            videoContainerCss = {
              left: '0',
              position: 'relative'
            };
          }

          if (!MobileHelper.isMobileDevice() || MobileHelper.isNativeIpadApp) {
            if (!pausedWhileEngaged && !Sension.faceHidden() && (!Sension.requireEngagement() || Sension.isEngaged())) {
              videoControl.play();
            } else if (Sension.requireEngagement() || Sension.faceHidden()) {
              videoControl.pause();
            }
          }

          // If using Flash Sension then we need to move the video around so there's no possibility of having
          // the flash video camera on top of our flash videojs video.
          if (!MobileHelper.isNativeIpadApp)
            videoContainer.css(videoContainerCss);
        }

        function seekToProgress() {
          setTimeout(function() {
            // If the current time is within a couple of seconds of the progressSeconds then just let it
            // slide. This seems to only be important when using Flash.
            if (videoControl.getCurrentTime() < (videoControl.slide.progressSeconds - 2)) {
              videoControl.seek(videoControl.slide.progressSeconds);
              seekToProgress();
            }
          }, 50);
        }

        function setupVideoJS(params) {
          if (!videoControl || !videoState) return;

          params = params || {};

          if (videoControl.slide.narrationPath) {
            // TODO: DE12802 turn off HLS if we have a narration path for zencoder bug
            params.noHLS = true;
          }

          scope.lastLoadStep = 'setting up options for initializing VideoJS';

          // Save a copy of the video element before it's set up by video.js in case we get an error.
          copyOfVideoElem = videoJsElem.clone(true);

          scope.setInitialVideoSource(params);

          var videoJsOptions = {
            usingNativeControls: MobileHelper.willGoNativeFullScreen(),
            preload: !MobileHelper.isMobileDevice() || MobileHelper.isNativeIpadApp ? 'metadata' : 'none',
            autoplay: false
          };
          if (MobileHelper.isIpad())
            videoJsOptions.iFrameMode = false;

          var techOrder = scope.getTechOrder(params);

          if (!techOrder) {
            scope.showHasNoVideoTechError();
            return;
          }
          videoJsOptions.techOrder = techOrder;

          scope.lastLoadStep = 'about to initialize VideoJS';

          // If nothing has loaded at all after 20 seconds see if we can successfully load it another way
          // (i.e. using MP4 instead of HLS or Flash instead of HTML5 video).
          videoNotLoadedTimeoutPromise = $timeout(onVideoHasNotLoaded, 20000);
          try {
            videojs('#video', videoJsOptions, function() {
              scope.lastLoadStep = 'has initialized VideoJS';
              videoJsPlayer = this;
              videoJsElem = $('#video');
              rawVideoElem = $('video');

              if (MobileHelper.isMobileDevice() && !MobileHelper.isNativeIpadApp) {
                videoJsElem.on('click', onVideoTap);
                videoJsElem.on('touchend', onVideoTap);
              }

              // If we think they're using flash and nothing loads after 15 seconds then show an error
              // that they may need to activate the plugin due to it being blocked.
              var isFirefox = $window.BrowserDetect && $window.BrowserDetect.browser == 'Firefox';
              if (isFirefox && (videoJsOptions.techOrder[0] == 'flash' || !scope.canPlayHtml5Video))
                pluginBlockedTimeoutPromise = $timeout(scope.showPluginBlockedError, 25000);

              loadVideo();
              resizeVideo();

              if (!MobileHelper.isNativeIpadApp)
                scope.onReadyToStartPlaying();

              if (rawVideoElem && rawVideoElem.length > 0 && rawVideoElem[0]) {
                rawVideoElem.on('canplay', function() {
                  canPlay = true;
                  if (videoState.deferredSeekTime) {
                    if (!pausedBeforeVideoSourceChange)
                      delayedPlay(300);
                    else
                      videoControl.pause();
                  }
                })
              }

              videoJsPlayer.on('loadedmetadata', function(e) {
                try {
                  scope.lastLoadStep = 'Received video metadata';
                  cancelPluginBlockedTimeout();
                  cancelVideoNotLoadedTimeout();
                  resizeVideo();

                  if (MobileHelper.isNativeIpadApp)
                    scope.onReadyToStartPlaying();

                  // Mute the sound as we're switching sources until we've seeked to spot previous source was at.
                  if (videoState.deferredSeekTime)
                    videoJsPlayer.volume(0);

                  SpinnerHelper.hideAllSpinners();
                  videoJsElem.removeClass('hideOffscreen');
                  videoJsElem.addClass('metadata-loaded');
                  usingFlash = (videoContainer.find('object').length > 0);
                  checkIfCanModifyVolume();

                  if (MobileHelper.isNativeIpadApp) {
                    // Tell it to play after loading the metadata. When the data has loaded then figure out
                    // if it should actually play. This is needed for iPad.
                    delayedPlay(300);
                  }

                  if (usingFlash) {
                    canPlay = true;
                    var usingSension = (!MobileHelper.isMobileDevice() || MobileHelper.isNativeIpadApp) && Sension.enabled();
                    // Tell it to play after loading the metadata. When the data has loaded then figure out
                    // if it should actually play. This is needed for flash fallback. If flash fallback with
                    // Sension but user isn't engaged then don't play yet.
                    if (usingSension && !Sension.isEngaged()) {
                      sensionEngagementChanged();
                    } else {
                      delayedPlay(300);
                    }
                  }
                } catch (e) {
                  onError(e);
                }
              });
              videoJsPlayer.on('playing', function(e) {
                try {
                  // In FF8 somehow this is getting called as soon as the video ends with no stack
                  // To deal with this just exit out if we get here within a second of the video ending.
                  if (justEnded)
                    return;

                  onErrorRetry = true;
                  scope.lastLoadStep = 'Started playing video';

                  cancelPluginBlockedTimeout();
                  cancelVideoNotLoadedTimeout();
                  SpinnerHelper.hideAllSpinners();
                  if (!scope.hasPlayed) {
                    scope.hasPlayed = true;
                    // Set volume to whatever setting was on previous slide.
                    setVolume();
                  }
                  scope.currentSourceHasPlayed = true;
                  videoContainer.removeClass('has-not-played');

                  if (!videoState.state || videoState.state == states.paused || videoState.state == states.ended || videoState.state == states.starting) {
                    // Media controls, etc. need to know it's playing.
                    videoControl.play();
                  }

                  if (Sension.enabled()) {
                    setTimeout(function() {
                      Sension.mediaPlaying(videoControl.getCurrentTime());
                    }, 1);
                  }

                  if (videoState.deferredSeekTime)
                    videoControl.seek(videoState.deferredSeekTime, finishedSeekingToPreviousSourcesTime);
                } catch (e) {
                  onError(e);
                }
              });
              videoJsPlayer.on('pause', function(e) {
                try {
                  pausedWhileEngaged = Sension.isEngaged();
                  videoControl.pause();
                  if (Sension.enabled()) {
                    // Ensure this is asyncronous so that there's not an apply in progress.
                    setTimeout(function() {
                      scope.$apply(function() {
                        Sension.mediaPaused(videoControl.getCurrentTime());
                      });
                    }, 1);
                  }
                } catch (e) {
                  onError(e);
                }
              });
              videoJsPlayer.on('loadeddata', function(e) {
                try {
                  scope.lastLoadStep = 'Received video data';

                  cancelPluginBlockedTimeout();
                  cancelVideoNotLoadedTimeout();
                  SpinnerHelper.hideAllSpinners();

                  // No need to track progress anymore if they've previously seen the entire video.
                  calculateTrackProgress();
                  isTrackingProgress = false;

                  if (videoControl.trackProgress) {
                    isTrackingProgress = true;
                    FrameStateProgressHelper.setup({
                      cModuleId: scope.cModuleId,
                      frameId: videoControl.slide.id,
                      initialProgress: videoControl.slide.progressSeconds
                    }, videoControl.getCurrentTime);

                    if (videoControl.slide.progressSeconds > 0 && !videoState.deferredSeekTime)
                      seekToProgress();
                  }

                  if (!MobileHelper.isMobileDevice() || MobileHelper.isNativeIpadApp) {
                    if (Sension.enabled()) {
                      Sension.mediaSetup({
                        identifier: videoControl.slide.id,
                        duration: Math.ceil(videoControl.getDuration())
                      });

                      sensionEngagementChanged();
                    } else {
                      delayedPlay();
                    }
                  } else {
                    videoState.state = states.paused;
                  }
                } catch (e) {
                  onError(e);
                }
              });
              videoJsPlayer.on('ended', function(e) {
                try {
                  videoState.state = states.ended;
                  justEnded = true;
                  $timeout(function() {
                    justEnded = false;
                  }, 1000);
                } catch (e) {
                  onError(e);
                }
              });
              videoJsPlayer.on('error', function(err) {
                onErrorEvent(err);
              });
            });
          } catch (err) {
            onError(err);
          }
        }

        function onVideoTap() {
          if (videoControl && videoControl.play && !scope.hasPlayed) {
            videoContainer.removeClass('touch-to-play');
            videoControl.play();
          }
        }

        function finishedSeekingToPreviousSourcesTime() {
          // If the video isn't ready yet video.js swallows the error and logs to the console. Keep
          // trying until the video is ready. Only actually seen this in IE9 HTML5 video.
          if (isIE9 && !usingFlash && videoState.deferredSeekTime != videoJsPlayer.currentTime()) {
            $timeout(function() {
              videoControl.seek(videoState.deferredSeekTime, finishedSeekingToPreviousSourcesTime);
            }, 50);
            return;
          }
          setVolume();
          videoState.deferredSeekTime = null;
          if (pausedBeforeVideoSourceChange)
            videoControl.pause();
          pausedBeforeVideoSourceChange = false;
        }

        function onErrorEvent(err) {
          var innerError = null;
          if (videoJsPlayer)
            innerError = videoJsPlayer.error();
          if (innerError) {
            onError(innerError);
          } else {
            onError(err);
          }
        }

        function onError(err) {
          $timeout(function() {
            var handledError = false;
            SpinnerHelper.hideAllSpinners();
            if (err) {
              if (err.code == 1) { // Message: You aborted the video playback.
                handledError = true;
              } else if (canRetryWithoutHLS(err)) {
                handledError = true;
                retrySetupVideoJS({ noHLS: true });
              } else if (canRetryWithFlash(err)) {
                handledError = true;
                retrySetupVideoJS({ forceFlash: true });
              }
            }

            if (!handledError) {
              destroyVideoJs();
              scope.showGenericContentError();
              scope.videoFullError = Utils.stringifyOnce(err);
              throw new Error('Video error: ' + scope.videoFullError);
            }
            onErrorRetry = false;
          });
        }

        function onVideoHasNotLoaded() {
          if (hasRetriedAfterVideoNotLoading) return;

          if (canRetryWithoutHLS()) {
            hasRetriedAfterVideoNotLoading = true;
            retrySetupVideoJS({ noHLS: true });
          } else if (canRetryWithFlash()) {
            hasRetriedAfterVideoNotLoading = true;
            retrySetupVideoJS({ forceFlash: true });
          }
        }

        function canRetryWithFlash(err) {
          var canRetryWithFlash = !usingFlash && scope.hasFlash;
          if (err)
            canRetryWithFlash = canRetryWithFlash && onErrorRetry && !!~retryableErrorCodes.indexOf(err.code);
          return canRetryWithFlash;
        }

        function canRetryWithoutHLS(err) {
          var canRetryWithoutHLS = videoState.sourceType == videoState.sourceTypes.hls;
          if (err)
            canRetryWithoutHLS = canRetryWithoutHLS && onErrorRetry && !!~retryableErrorCodes.indexOf(err.code);
          return canRetryWithoutHLS;
        }

        function retrySetupVideoJS(params) {
          scope.deferredSeekTime = lastSeenCurrentTime;

          Navigation.state = Navigation.states.loading;
          SpinnerHelper.showLoadingSpinner();

          // Destroying video.js deletes our video element from the DOM.
          destroyVideoJs();

          // Use our copy of the video element before being initialized by video.js and apply it
          // to the DOM so we can reinitialize using Flash.
          videoJsElem = copyOfVideoElem;
          videoJsElem.appendTo(videoWrapper);
          $timeout(function() {
            setupVideoJS(params);
          }, 1);
        }

        function delayedPlay(ms) {
          ms = ms || 500;
          setTimeout(videoControl.play, ms);
        }

        function ensurePaused() {
          var tryAgain = true;
          if (videoJsPlayer && !videoJsPlayer.paused())
            videoControl.pause();
          else
            tryAgain = false;

          if (tryAgain)
            setTimeout(function() {
              ensurePaused();
            }, 50);
        }

        function loadVideo() {
          if (!videoControl || !videoState || !videoJsPlayer) return;

          if (scope.currentSourceHasPlayed && !videoState.deferredSeekTime) {
            videoState.deferredSeekTime = videoJsPlayer.currentTime();
            pausedBeforeVideoSourceChange = videoJsPlayer.paused();
          }

          videoJsElem.removeClass('metadata-loaded');

          // Hasn't played newly loaded video source so reset flag.
          scope.currentSourceHasPlayed = false;
          canPlay = false;

          videoJsPlayer.src({
            src: videoState.videoSrc,
            type: videoState.sourceType == videoState.sourceTypes.hls ? 'application/x-mpegURL' : 'video/mp4'
          });
          videoJsPlayer.load();

          scope.lastLoadStep = 'requested video to load';

          // Hide video off screen until Quicktime logo won't show but bring slide back on screen at this point
          if (MobileHelper.isNativeIpadApp)
            videoJsElem.addClass('hideOffscreen');

          if (!pausedBeforeVideoSourceChange && (!MobileHelper.isMobileDevice() || MobileHelper.isNativeIpadApp)) {
            setTimeout(function() {
              SpinnerHelper.showMinorSpinner();
            }, 1);
          }

          //Autoplay isn't reliable on ipad, so give the video a chance to initialize a bit, then force it to play.
          if (!scope.hasPlayed && MobileHelper.isNativeIpadApp) {
            setTimeout(function() {
              videoControl.play();
            }, 100);
          }
        }

        function checkIfCanModifyVolume() {
          if (!videoJsPlayer) return;
          // We already know whether they can mute so quit.
          if (typeof $rootScope.canMute == 'boolean')
            return;

          var volume = videoJsPlayer.volume();
          if (volume <= .9) {
            videoJsPlayer.volume(volume + 0.1);
            $rootScope.canMute = (videoJsPlayer.volume() == volume + 0.1);
            videoJsPlayer.volume(volume);
          } else {
            videoJsPlayer.volume(volume - 0.1);
            $rootScope.canMute = (videoJsPlayer.volume() == volume - 0.1);
            videoJsPlayer.volume(volume);
          }
        }

        angular.element($window).on('resize', resizeVideo);

        scope.$watch('mediaState.sourceType', function(sourceType) {
          if (!videoState || !videoControl) return;

          if (videoState.sourceType == videoState.sourceTypes.hls)
            videoState.videoSrc = videoControl.slide.hLSContentPath;
          else if (videoState.sourceType == videoState.sourceTypes.hd)
            videoState.videoSrc = videoControl.slide.contentPath;
          else if (videoState.sourceType == videoState.sourceTypes.sd)
            videoState.videoSrc = videoControl.slide.sDContentPath;
          else
            videoState.videoSrc = videoControl.slide.lowQualityContentPath;

          loadVideo();
          resizeVideo();
        });

        scope.$on('$destroy', function() {
          cancelPluginBlockedTimeout();
          cancelVideoNotLoadedTimeout();

          if (intervalId)
            clearInterval(intervalId);

          videoControl.pause();

          if (isTrackingProgress) {
            calculateTrackProgress();
            FrameStateProgressHelper.updateProgress();
          }
          FrameStateProgressHelper.destroy();

          destroyVideoJs();

          videoContainer.off('resize');
          angular.element($window).off('resize', resizeVideo);

          videoState.videoSrc = "";

          if (supportsFullscreen) {
            $window.document.removeEventListener('fullscreenchange', onFullscreenChange, false);
            $window.document.removeEventListener('webkitfullscreenchange', onFullscreenChange, false);
            $window.document.removeEventListener('mozfullscreenchange', onFullscreenChange, false);
            $window.document.removeEventListener('MSFullscreenChange', onFullscreenChange, false);
          }
        });

        function cancelPluginBlockedTimeout() {
          if (pluginBlockedTimeoutPromise) {
            $timeout.cancel(pluginBlockedTimeoutPromise);
            pluginBlockedTimeoutPromise = null;
          }
        }

        function cancelVideoNotLoadedTimeout() {
          if (videoNotLoadedTimeoutPromise) {
            $timeout.cancel(videoNotLoadedTimeoutPromise);
            videoNotLoadedTimeoutPromise = null;
          }
        }

        function destroyVideoJs() {
          if (videoJsElem) {
            videoJsElem.off('click', onVideoTap);
            videoJsElem.off('touchend', onVideoTap);
          }

          if (videoJsPlayer) {
            // unload the current video so it does not keep downloading
            videoJsPlayer.src('');
            videoJsPlayer.load();

            videoJsPlayer.pause();
            videoJsPlayer.off('loadedmetadata');
            videoJsPlayer.off('playing');
            videoJsPlayer.off('pause');
            videoJsPlayer.off('loadeddata');
            videoJsPlayer.off('ended');
            videoJsPlayer.off('error');
            videoJsPlayer.dispose();
            videoJsPlayer = null;
          }

          _.each(videoJsElem, function(singleVideoElem) {
            singleVideoElem.player = null;
          });
        }

        function calculateTrackProgress() {
          if (!videoControl.getCurrentTime || !videoControl.getDuration)
            return;

          videoControl.slide.progressSeconds = Math.max(videoControl.slide.progressSeconds, Math.floor(videoControl.getCurrentTime()));
          videoControl.trackProgress = !scope.isPreview && !scope.completionInfo &&
            //videoControl.slide.status != 117000200 /*Completed*/ &&
            (videoControl.getDuration() - 1) > videoControl.slide.progressSeconds &&
            (Navigation.slideIndex == (Navigation.numUnlockedSlides - 1)) &&
            Navigation.playerType == Navigation.playerTypes.trainee;
        }

        intervalId = setInterval(function() {
          if (!videoJsPlayer) return;

          calculateTrackProgress();
          lastSeenCurrentTime = videoControl.getCurrentTime();

          if (videoJsPlayer.paused()) {
            scope.$apply(function() {
              if (videoState.state == states.playing) {
                scope.mediaState.state = states.paused;
              }
            });
          } else {
            if (Sension.enabled())
              Sension.updateTimestamp(lastSeenCurrentTime);
          }

          scope.checkIfBuffering();
        }, 500);
      }
    };
  }
})();
